import { Grid, Paper } from '@mui/material';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { useGlobals } from 'src/shared/contexts/appContext';
import { MemberChartV2 } from './memberChartV2';
import { MemberStatsBoxes } from './memberStatsBoxes';
import { AutojobsChart } from '../autojobs/autojobsChart';

type MemberDashboardProps = {
  associationId: number | undefined;
  districtId: number | undefined;
};

export const MemberDashboard = (props: MemberDashboardProps) => {
  const { associationId, districtId } = props;
  const { currentUser } = useGlobals();

  const canSeeAutoJobs = getPermission(currentUser, PermissionEnum.MemberReadAll);
  return (
    <>
      <MemberStatsBoxes associationId={associationId} districtId={districtId} />
      <Grid item xs={12} md={canSeeAutoJobs ? 6 : 12}>
        <Paper sx={{ p: 2 }}>
          <MemberChartV2 associationId={associationId} districtId={districtId} />
        </Paper>
      </Grid>
      {canSeeAutoJobs && (
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <AutojobsChart />
          </Paper>
        </Grid>
      )}
    </>
  );
};
